import {request} from "./request";


// 获取客户详情页 -- 客户跟进
export function getrecord_list2(customer_id, page, pagesize) {
    return request({
        url: '/hkt/customerfollowrecord/get_customer_follow_record_list2',
        params: {
            class_type: 0,	
            sort_type: 1,	
			pagesize,
			page,
			customer_id,
        }
    })
}
// 获取企微客户详情
export function get_qw_customer_details(external_userid) {
    return request({
        url: '/hkt/customer/get_qw_customer_details',
        params: {
            external_userid, //	是	string	外部联系人id
        }
    })
}

// 修改客户详细 post
export function editCustome2(data) {
    return request({
        url: '/hkt/customer/edit_customer_info',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data,
    })
}
// 修改客户详细 
export function editCustomerInfos(customer_id, customer_info) {
    return request({
        url: '/hkt/customer/edit_customer_info',
        params: {
            customer_id,	
            customer_info,	
        }
    })
}

// 修改线索详细
export function editCue2Info(data) {
    return request({
        url: '/hkt/cuepool/edit_cue_pool_info',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data,
    })
}
export function distributeCustomer(customer_id, member_id) {
    return request({
        url: '/hkt/customer/distribute_customer',
        params: {
            customer_id,
            member_id
        }
    })
}
// 公海客户转为客户
export function distributePublicCustomer(customer_id, member_id) {
    return request({
        url: '/hkt/customer/distribute_public_customer',
        params: {
            customer_id,
            member_id
        }
    })
}
// 删除公海客户
export function delPublicCustomer(customer_id) {
    return request({
        url: '/hkt/customer/del_public_customer',
        params: {
            customer_id,
        }
    })
}

// 客户 退回公海
export function releaseCustomers(customer_id) {
    return request({
        url: '/hkt/customer/release_customer_member',
        params: {
			customer_id,
        }
    })
}

// 删除 公海线索
export function delCuePool(cue_id) {
    return request({
        url: '/hkt/Cuepool/del_cue_pool',
        params: {
			cue_id,
        }
    })
}

// 获取线索列表
export function getCuePool(pagesize, page, type, source, member_id, search_name, is_lock) {
    return request({
        url: '/hkt/cuepool/get_cue_pool',
        params: {
            pagesize,
            page,
            type,
            source,
            member_id,
            search_name,
			is_lock,
        }
    })
}
// 获取线索列表
export function getlistCuePools(params) {
    return request({
        url: '/hkt/cuepool/get_cue_pool',
        params,
    })
}
// 释放线索
export function releaseCuePool(cue_id) {
    return request({
        url: '/hkt/cuepool/release_cue_pool',
        params: {
            cue_id
        }
    })
}

// 分配线索
export function distributeCuePool(cue_id, member_id, is_lock) {
    return request({
        url: '/hkt/cuepool/distribute_cue_pool',
        params: {
            cue_id,
            member_id,
			is_lock,
        }
    })
}
// 导入线索
export function importBatchCuePool(data) {
    return request({
        url: '/hkt/cuepool/import_batch_cue_pool',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data
    })
}
// 置为客户
export function changeCuePoolToCustomer(cue_id) {
    return request({
        url: '/hkt/cuepool/change_cue_pool_to_customer',
        params: {
            cue_id
        }
    })
}
// 置为客户2
// cue_id	是	string	线索id
// name	是	string	姓名
// customer_type	是	int	客户类型
// customer_info	是	string	客户信息
// export function changoCustomer(params) {
//     return request({
//         url: '/hkt/cuepool/change_cue_pool_to_customer2',
//         params,
//     })
// }

export function changoCustomer(data) {
	return request({
	    url: '/hkt/cuepool/change_cue_pool_to_customer2',
	    method: 'post',
	    headers: {
	        'Content-Type': 'multipart/form-data'
	    },
	    data,
	})			    
}

// 线索详情
export function getCuePoolDetails(cue_id) {
    return request({
        url: '/hkt/cuepool/get_cue_pool_details',
        params: {
            cue_id
        }
    })
}

//  获取客户来源 选择
export function getfollow_up_list() {
    return request({
        url: '/hkt/customerfollowup/get_customer_follow_up_list',
        params:{
			type: 4,
			pagesize: 99,
		},
    })
}

// 线索配置信息
export function getCustomerInfoStoreConfig() {
    return request({
        url: '/hkt/cuepool/get_customer_info_store_config',
        params: {

        }
    })
}
// 录入线索
export function importCuePool(data) {
    return request({
        url: '/hkt/cuepool/import_cue_pool',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data
    })
}

// 录入线索


// 客户设置

// 获取跟进方式列表
export function getCustomerFollowUpList(type, pagesize, page) {
    return request({
        url: '/hkt/customerfollowup/get_customer_follow_up_list',
        params: {
            type,
            pagesize,
            page
        }
    })
}
// 添加跟进方式
export function addCustomerFollowUp(type, name, describe) {
    return request({
        url: '/hkt/customerfollowup/add_customer_follow_up',
        params: {
            type,
            name,
            describe
        }
    })
}
// 编辑跟进方式
export function editCustomerFollowUp(id, name, describe) {
    return request({
        url: '/hkt/customerfollowup/edit_customer_follow_up',
        params: {
            id,
            name,
            describe
        }
    })
}
// 删除跟进方式
export function delCustomerFollowUp(id) {
    return request({
        url: '/hkt/customerfollowup/del_customer_follow_up',
        params: {
            id,
        }
    })
}
// 获取客户信息列表
export function getCustomerInfoConfig(pagesize, page) {
    return request({
        url: '/hkt/customerinfoconfig/get_customer_info_config',
        params: {
            pagesize,
            page
        }
    })
}
// 添加客户信息
export function addCustomerInfoConfig(field, field_type, type, is_state, field_config) {
    return request({
        url: '/hkt/customerinfoconfig/add_customer_info_config',
        params: {
            field,
            field_type,
            type,
            is_state,
            field_config
        }
    })
}
// 修改客户信息
export function editCustomerInfoConfig(id, field, type, is_state, field_config) {
    return request({
        url: '/hkt/customerinfoconfig/edit_customer_info_config',
        params: {
            id,
            field,
            type,
            is_state,
            field_config
        }
    })
}
// 删除客户信息
export function delCustomerInfoConfig(id) {
    return request({
        url: '/hkt/customerinfoconfig/del_customer_info_config',
        params: {
            id
        }
    })
}
// 删除客户信息
export function operationCustomerInfoConfig(id, is_state) {
    return request({
        url: '/hkt/customerinfoconfig/operation_customer_info_config',
        params: {
            id,
            is_state
        }
    })
}

// 客户标签
// 获取标签列表
export function getCustomerTagList(pagesize, page) {
    return request({
        url: '/hkt/customertag/get_customer_tag_list',
        params: {
            pagesize,
            page
        }
    })
}
// 添加标签
export function addCustomerTag(tag_group_name, tag_name) {
    return request({
        url: '/hkt/customertag/add_customer_tag',
        params: {
            tag_group_name,
            tag_name
        }
    })
}
// 删除标签
export function delCustomerTag(group_id) {
    return request({
        url: '/hkt/customertag/del_customer_tag',
        params: {
            group_id
        }
    })
}
// 编辑标签
export function editCustomerTag(group_id, tag_group_name, edit_tag_info, del_tag_info, add_tag_info) {
    return request({
        url: '/hkt/customertag/edit_customer_tag',
        params: {
            group_id,
            tag_group_name,
            edit_tag_info,
            del_tag_info,
            add_tag_info
        }
    })
}

// 客户列表
// 获取客户列表
// pagesize,
//             page,
//             search_name,
//             member_id,
//             follow_id,
//             search_time,
export function getCustList2(params) {
    return request({
        url: '/hkt/customer/get_customer_list',
        params,
    })
}
export function getCustomerL2(params) {
    return request({
        url: '/hkt/customer/get_customer_list',
        params,
    })
}

export function getCustomerList(pagesize, page, search_name, member_id, follow_id, search_time) {
    return request({
        url: '/hkt/customer/get_customer_list',
        params: {
            pagesize,
            page,
            search_name,
            member_id,
            follow_id,
            search_time,
        }
    })
}
export function getCustomerPublicList(pagesize, page, search_name, member_id, follow_id, search_time) {
    return request({
        url: '/hkt/customer/get_customer_public_list',
        params: {
            pagesize,
            page,
            search_name,
            member_id,
            follow_id,
            search_time,
        }
    })
}
// 获取公海客户列表
export function getPublicLists(params) {
    return request({
        url: '/hkt/customer/get_customer_public_list',
        params,
    })
}
// 获取客户详情
export function getCustomerDetails(customer_id) {
    return request({
        url: '/hkt/customer/get_customer_details',
        params: {
            customer_id,
        }
    })
}
// 获取客户信息
export function getCustomerInfo(customer_id) {
    return request({
        url: '/hkt/customer/get_customer_info',
        params: {
            customer_id,
        }
    })
}
// 录入客户
// name	是	string	名称
// phone	是	int	手机
// lock	是	int	是否公海客户
// customer_info	是	string	客户信息
// contact_id	是	int	联系人id
export function importCustomer(data) {
    return request({
        url: '/hkt/customer/import_customer',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data
    })
}
// 导入客户
export function importBatchCustomer(data) {
    return request({
        url: '/hkt/customer/import_batch_customer',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data
    })
}
// 获取线索客户信息
export function getClueInfo(customer_id) {
    return request({
        url: '/hkt/customerinfo/get_customer_info',
        params: {
            customer_id,
        }
    })
}
// 编辑客户信息
export function editCustomerInfo(customer_id, customer_info) {
    return request({
        url: '/hkt/customer/edit_customer_info',
        params: {
            customer_id,
            customer_info,
        }
    })
}
// 编辑线索信息
export function editClueInfo(general_info, cue_id) {
    return request({
        url: '/hkt/customerinfo/edit_customer_info',
        params: {
            general_info,
            cue_id,
        }
    })
}
// 编辑标签
export function editCustomerInfoTag(customer_id, tag_type, tag_id) {
    return request({
        url: '/hkt/customer/add_customer_tag',
        params: {
            customer_id,
            tag_type,
            tag_id
        }
    })
}
// 编辑协同人
export function addCustomerAssistantMember(customer_id, assistant_member_id) {
    return request({
        url: '/hkt/customer/edit_customer_assistant_member',
        params: {
            customer_id,
            assistant_member_id
        }
    })
}
// 修改客户状态
export function editCustomer(customer_id, follow_id, state) {
    return request({
        url: '/hkt/customer/edit_customer',
        params: {
            customer_id,
            follow_id,
            state
        }
    })
}
// 修改客户状态
// customer_id,
//             follow_id,
//             state
export function editCustomer2(params) {
    return request({
        url: '/hkt/customer/edit_customer',
        params,
    })
}

// 转到公海
export function releaseCustomerMember(customer_id) {
    return request({
        url: '/hkt/customer/release_customer_member',
        params: {
            customer_id,
        }
    })
}



// 跟进记录
// 获取跟进记录列表
export function getCustomerFollowRecordList(pagesize, page, customer_name, way, type, member_id, assistant_member_id, search_time) {
    return request({
        url: '/hkt/customerfollowrecord/get_customer_follow_record_list',
        params: {
            pagesize,
            page,
            customer_name,
            way,
            type,
            member_id,
            assistant_member_id,
            search_time
        }
    })
}


// pagesize	是	int	页码
// search_name	否	string	客户名字
// way	否	int	方式id
// type	否	int	类型id
// member_id	否	int	成员id
// assistant_member_id	否	int	跟进成员id
// search_time	否	string	时间
// customer_id	否	int	客户id
// chance_id	否	int	商机id
// contract_id	否	int	合同id
// return_id	否	int	放款id
// project_id	否	int	项目id
export function getFollowList(params) {
    return request({
        url: '/hkt/customerfollowrecord/get_customer_follow_record_list',
        params,
    })
}
// 
// 写跟进
export function addCustomerFollowRecord(customer_id, member_id, assistant_member_id, follow_time, way, type, content) {
    return request({
        url: '/hkt/customerfollowrecord/add_customer_follow_record',
        params: {
            customer_id,
            member_id,
            assistant_member_id,
            follow_time,
            way,
            type,
            content,
			
        }
    })
}

// 修改 跟进记录
export function edit_follow_record(data) {
    return request({
         url: '/hkt/customerfollowrecord/edit_customer_follow_record',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data,
	})
}

// 删除跟进记录
export function delCustomerFollowRecord(ids) {
    return request({
        url: '/hkt/customerfollowrecord/del_customer_follow_record',
        params: {
            ids,
        }
    })
}
// 创建客户计划
export function addCustomerFollowPlan(customer_id, start_time, content) {
    return request({
        url: '/hkt/customerfollowplan/add_customer_follow_plan',
        params: {
            customer_id,
            start_time,
            content,
        }
    })
}
// 删除客户计划
export function delCustomerFollowPlan(customer_id) {
    return request({
        url: '/hkt/customerfollowplan/del_customer_follow_plan',
        params: {
            customer_id,
        }
    })
}
// 获取客户计划列表
export function getCustomerFollowPlanList(pagesize, page, search_time, member_id, customer_name) {
    return request({
        url: '/hkt/customerfollowplan/get_customer_follow_plan_list',
        params: {
            pagesize,
            page,
            search_time,
            member_id,
            customer_name
        }
    })
}
// 修改客户计划
export function editCustomerFollowPlan(id, start_time, content) {
    return request({
        url: '/hkt/customerfollowplan/edit_customer_follow_plan',
        params: {
            id,
            start_time,
            content
        }
    })
}
// 删除客户计划
export function delCustomerPlan(id) {
    return request({
        url: '/hkt/customerfollowplan/del_customer_follow_plan',
        params: {
            id,
        }
    })
}


// 客户动态
// 获取客户跟进动态
export function getFollowUpRecord(pagesize, page, customer_id) {
    return request({
        url: '/hkt/customeroperationrecord/get_follow_up_record',
        params: {
            pagesize,
            page,
            customer_id
        }
    })
}
// 获取计划动态
export function getFollowPlanRecord(pagesize, page, customer_id) {
    return request({
        url: '/hkt/customeroperationrecord/get_follow_plan_record',
        params: {
            pagesize,
            page,
            customer_id
        }
    })
}
// 获取修改信息动态
export function getEditCustomerInfo(pagesize, page, customer_id) {
    return request({
        url: '/hkt/customeroperationrecord/get_edit_customer_info',
        params: {
            pagesize,
            page,
            customer_id
        }
    })
}
// 获取客户商品动态
export function getGoodsRecord(pagesize, page, customer_id) {
    return request({
        url: '/hkt/customeroperationrecord/get_goods_record',
        params: {
            pagesize,
            page,
            customer_id
        }
    })
}
// 获取线索商品动态
export function getGoodsRecord1(pagesize, page, cue_id) {
    return request({
        url: '/hkt/customeroperationrecord/get_goods_record',
        params: {
            pagesize,
            page,
            cue_id
        }
    })
}
// 获取客户浏览动态
export function getVisitRecord(pagesize, page, customer_id) {
    return request({
        url: '/hkt/customeroperationrecord/get_visit_record',
        params: {
            pagesize,
            page,
            customer_id
        }
    })
}
// 获取线索浏览动态
export function getVisitRecord1(pagesize, page, cue_id) {
    return request({
        url: '/hkt/customeroperationrecord/get_visit_record',
        params: {
            pagesize,
            page,
            cue_id
        }
    })
}
// 获取客户全部信息动态
export function getAllOperationRecord(pagesize, page, customer_id) {
    return request({
        url: '/hkt/customeroperationrecord/get_all_operation_record',
        params: {
            pagesize,
            page,
            customer_id
        }
    })
}
// 获取线索全部信息动态
export function getAllOperationRecord1(pagesize, page, cue_id) {
    return request({
        url: '/hkt/customeroperationrecord/get_all_operation_record',
        params: {
            pagesize,
            page,
            cue_id
        }
    })
}


// 联系人000000000000000000000000000000000000000000000
// 联系人 分类 添加
export function lxr_addcongroup(name) {
    return request({
        url: '/hkt/contactgroup/add_contact_group',
        params: {
           name,
        }
    })
}

// 联系人 分类 删除
export function lxr_delcongroup(group_id) {
    return request({
        url: '/hkt/contactgroup/del_contact_group',
        params: {
           group_id,
        }
    })
}

// 联系人 分类 修改
export function lxr_editcongroup(group_id, name) {
    return request({
        url: '/hkt/contactgroup/edit_contact_group',
        params: {
           group_id,
		   name,
        }
    })
}


// 联系人 分类 列表
export function lxr_listcongroup() { 
    return request({
        url: '/hkt/contactgroup/get_contact_group_list',
        params: {
           pagesize: 999,
        }
    })
}

// 联系人 分类 排序
export function lxr_sortcongroup(group_ids) {
    return request({
        url: '/hkt/contactgroup/sort_contact_group',
        params: {
			group_ids,
        }
    })
}
// ========================

// 联系人000000000000000000000000000000000000000000000
// 联系人 字段 添加
// field	是	string	联系人字段
// field_type	是	int	字段类型0:系统类型1:单行文本2:多行文本3：时间4：数字5：单选6：多选7:附件8：图片
// group_id	是	int	分组id
// state	是	int	启用状态0:不启用1：启用
// field_config	否	string	字段配置
export function lxr_addconfield(params) {
    return request({
        url: '/hkt/contactfield/add_contact_field',
        params,
    })
}

// 联系人 字段 删除
export function lxr_delconfield(field_id) {
    return request({
        url: '/hkt/contactfield/del_contact_field',
        params: {
			field_id,
		},
    })
}


// 联系人 字段 修改
// field_id	是	int	id
// field	是	string	商机字段
// group_id	是	int	分组id
// state	是	int	启用状态0:不启用1：启用
// field_config	否	string	字段配置
export function lxr_editconfield(params) {
    return request({
        url: '/hkt/contactfield/edit_contact_field',
        params,
    })
}

// 联系人 字段 修改状态
export function lxr_stateconfield(field_id, state) {
    return request({ 
        url: '/hkt/contactfield/operation_contact_field',
        params: {
			field_id, //	是	int	id
			state, //	是	int	状态
		},
    })
}

// 联系人 字段 列表1
export function lxr_list1confield(params) {
    return request({
        url: '/hkt/contactfield/get_contact_field_list',
        params,
    })
}
// 联系人 字段 列表2
export function lxr_list2confield() {
    return request({
        url: '/hkt/contactfield/get_contact_field_list2',
        params: {
			pagesize: 999,
		},
    })
}
// =========================================


// 联系人000000000000000000000000000000000000000000000
// 联系人 添加 post
// name	是	string	名称
// relation_type	是	int	关联类型1：线索2：客户
// customer_id	否	int	客户ID
// cue_id	否	int	线索ID
// phone	否	string	电话
// email	否	string	邮箱
// gender	否	int	性别1：男2：女:3：未知
// contact_info	是	string	合同信息
export function lxrl_add_contact(data) {
    return request({
        url: '/hkt/contact/add_contact',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data,
	})
}



// 联系人 修改 post
// contact_id	是	int	联系人id
// name	是	string	名称
// relation_type	是	int	关联类型1：线索2：客户
// customer_id	否	int	客户ID
// cue_id	否	int	线索ID
// phone	否	string	电话
// email	否	string	邮箱
// gender	否	int	性别1：男2：女:3：未知
// contact_info	是	string	合同信息
export function lxrl_edit_contact(data) {
    return request({
        url: '/hkt/contact/edit_contact',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data,
	})
}

// 联系人 删除
export function lxrl_del_contact(contact_ids) {
    return request({
        url: '/hkt/contact/del_contact',
        params: {
			contact_ids,
		},
    })
}

// 联系人 列表
// pagesize	是	int	每页数量
// contact_type	否	int	//1:有手机2:有邮箱
// sort_type	否	int	/1:最新创建:最新跟进
// search_name	否	string	名称
// search_type	否	int	类型
// is_main	否	string	//0：其他联系人1:主要联系人
// customer_id	否	int	客户id
// cue_id	否	int	线索id
export function lxrl_list_contact(params) {
    return request({
        url: '/hkt/contact/get_contact_list',
        params,
    })
}

// 联系人 单个详情
export function lxrl_details_contact(contact_id) {
    return request({
        url: '/hkt/contact/get_contact_details',
        params: {
			contact_id,
		},
    })
}

// 联系人 批量修改
export function lxrl_batch_contact(contact_ids, member_id) {
    return request({
        url: '/hkt/contact/batch_edit_contact',
        params: {
			contact_ids, // 	是	string	联系人id
			member_id, // 	是	int	成员id
		},
    })
}

// 获取客户模块列表
export function get_Module_list_all(params) {
    return request({
        url: '/hkt_admin/SystemModule/get_Module_list_all',
        params,
    })
}

// 

// 模块复制接口
export function get_Module_copy(data) {
    return request({
        url: '/hkt_admin/SystemModule/copy',
        params:{
            module_details_id:data
        },
    })
}

// 模块删除接口
export function del_Module(data) {
    return request({
        url: '/hkt_admin/SystemModule/del_module',
        params:{
            module_details_id:data
        },
    })
}

// 获取客户列表的表单数据
export function get_module_comtomer(projcet_div_id) {
    return request({
        url: '/hkt_admin/SystemModule/get_module_Type',
        params:{
            projcet_div_id: projcet_div_id,
        },
    })
}

// 修改表单的接口
export function updata_customer_form(data) {
    return request({
        url: '/hkt_admin/SystemModule/updata_module_details_type_form_data',
        method: 'post',
        data,
    })
}

// 修改模块
export function updata_Module_details(params) {
    return request({
        url: '/hkt_admin/SystemModule/updata_module_details',
        params:params,
    })
}

// 获取详情表单数据
export function get_customer_form_id(data,type,projcet_div_id) {
    return request({
        url: '/hkt_admin/SystemModule/get_module_details_type_form_data',
        params:{
            form_id:data,
            type: type,
            projcet_div_id: projcet_div_id
        },
    })
}
// 获取客户编号
export function get_customer_code(params) {
    return request({
        url: '/hkt_admin/SystemModule/get_customer_code',
        params,
    })
}